import yellow from '@material-ui/core/colors/yellow';
import BasicTile from './basic-tile';
import { ExtendedTheme } from '@sightworks/theme';

export default (theme: ExtendedTheme) => BasicTile(theme, 'min-content');
